import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

// Lazy loading con retry automático
const RisersPage = lazyWithRetry(
  () => import("./ui/pages/RisersPage"),
  "RisersPage",
);

/**
 * Rutas del módulo de risers
 * Admin (1), Inspector (2), Supervisor (3), Developer (5)
 * Nota: el rol Default (4) no tiene acceso a esta feature.
 */
const risersRoutes = buildRoutes([
  {
    path: "/planos-interactivos",
    element: RisersPage,
    roles: [1, 2, 3, 5],
  },
]);

export default risersRoutes;
